import { useState, useEffect } from "react";
import Aboutusimg from "../assests/Images/slide2.png";
import Getintouchimg from "../assests/Images/cruise-ship-miami.jpg";
import axios from "axios";
import { useLocation } from "react-router-dom";
import Alert from "react-bootstrap/Alert";
import Accordion from "react-bootstrap/Accordion";
import Footer from "../components/footer";
import Hero from "../components/hero";
import "../styles/home.css";
import Reviews from "../components/reviews";
import Services from "../components/services";
import AOS from "aos";
import "aos/dist/aos.css";
import Explorevideos from "../components/explorevideos";
import Affairs from "../components/affairs";
import ThankYouAnimation from "../components/Thankyou";

import { API_BASE_URL } from '../config/api';

function Home() {
  const [successAlert, setSuccessAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const animation = sessionStorage.getItem("homeanimation");
  const [anim] = useState(animation);
  
  // Country and phone states
  const [countries, setCountries] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState('IN');
  const [loadingCountries, setLoadingCountries] = useState(true);
  useEffect(() => {
    let timer;
    if (successAlert) {
      timer = setTimeout(() => {
        setSuccessAlert(false);
      }, 5000); // Hide success alert after 5 seconds
    }
    if (errorAlert) {
      timer = setTimeout(() => {
        setErrorAlert(false);
      }, 5000); // Hide error alert after 5 seconds
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [successAlert, errorAlert]);

  // Fetch countries with phone codes
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        // Set default countries immediately
        const defaultCountries = [
          { code: 'IN', name: 'India', phone: '+91' },
          { code: 'US', name: 'United States', phone: '+1' },
          { code: 'GB', name: 'United Kingdom', phone: '+44' },
          { code: 'AU', name: 'Australia', phone: '+61' },
          { code: 'CA', name: 'Canada', phone: '+1' },
        ];
        setCountries(defaultCountries);
        setLoadingCountries(false);
        console.log('Default countries set:', defaultCountries);
        
        // Try to fetch full list from API
        const response = await fetch(`${API_BASE_URL}/api/misc/countries/phone-codes/`);
        if (response.ok) {
          const data = await response.json();
          console.log('API response:', data);
          if (data.countries && Array.isArray(data.countries)) {
            setCountries(data.countries);
            console.log('Full countries set:', data.countries);
          }
        } else {
          console.log('API response not ok:', response.status);
        }
      } catch (error) {
        console.error('Error fetching countries:', error);
        // Keep default countries if API fails
      } finally {
        setLoadingCountries(false);
      }
    };

    fetchCountries();
  }, []);

  useEffect(() => {
    if (anim !== "true") {
      AOS.init({
        duration: 1000, // Optional: you can customize the animation duration or other settings
        once: true, // Optional: ensures animations only trigger once
        // easing:'ease-out',
        // offset: 100,
        startEvent: "DOMContentLoaded",
      });
    }
  }, [anim]);

  useEffect(() => {
    sessionStorage.setItem("homeanimation", "true");
  }, []);

  const getAosData = (anima, delay) => {
    return anim === "true"
      ? {}
      : { "data-aos": anima, "data-aos-delay": delay };
  };

  const [formData, setFormData] = useState({
    indos_no: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    country_code: "IN",
    date_of_birth: "",
    designation: "",
    location: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[name];
      return newErrors;
    });
  };
  const location = useLocation();
  useEffect(() => {
    // navigate("/#" + targetId); // Navigate to the home page
    const targetId = location.hash;
    const targetElement = document.getElementById(targetId.slice(1));
    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop + 50, // Adjust offset here
        behavior: "smooth", // Optional: for smooth scrolling
      });
    }
  }, [location.hash]);

  useEffect(() => {
    const handleAnchorClick = (event) => {
      // Check if the clicked link is an anchor link
      if (event.target.hash) {
        event.preventDefault();

        const targetId = event.target.hash;
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
          // Scroll to the element with a -50px offset
          window.scrollTo({
            top: targetElement.offsetTop - 120, // Adjust offset here
            behavior: "smooth", // Optional: for smooth scrolling
          });
        }
      }
    };

    // Add event listener to anchor links
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", handleAnchorClick);
    });

    // Cleanup event listener on component unmount
    return () => {
      document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
        anchor.removeEventListener("click", handleAnchorClick);
      });
    };
  }, []);

  const validateForm = () => {
    const { first_name, email, indos_no, date_of_birth, message } =
      formData;
    const errors = {};
    // Date of birth: no future date
    if (date_of_birth) {
      const today = new Date();
      const dob = new Date(date_of_birth);
      // Set time to 0 for both to compare only date
      today.setHours(0, 0, 0, 0);
      dob.setHours(0, 0, 0, 0);
      if (dob > today) {
        errors.date_of_birth = "Date of birth cannot be in the future.";
      }
    }
    // Make indos_no optional, but if provided, must be exactly 8 characters
    if (indos_no && indos_no.length !== 8) {
      errors.indos_no = "Indos Number must be exactly 8 characters.";
    }
    if (first_name === "") {
      errors.first_name = "First Name is required.";
    }
    if (email === "") {
      errors.email = "Email is required.";
    }
    if (message === "") {
      errors.message = "Message is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = "Email address is invalid.";
    }
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formErrors = validateForm();

    if (Object.keys(formErrors).length === 0) {
      // Prepare payload with phone number concatenation
      const payload = {};
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== "") {
          if (key === 'phone' && value && formData.country_code) {
            // Concatenate country code with phone number
            const selectedCountry = countries.find(c => c.code === formData.country_code);
            payload[key] = `${selectedCountry?.phone || '+91'}${value}`;
          } else if (key !== 'country_code') {
            // Skip country_code as it's only used for concatenation
            payload[key] = value;
          }
        }
      });
      
      axios
        .post(
          `${API_BASE_URL}/api/misc/inquiry/`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          setFormData({
            indos_no: "",
            first_name: "",
            last_name: "",
            email: "",
            phone: "",
            country_code: "IN",
            date_of_birth: "",
            designation: "",
            location: "",
            message: "",
          });
          setSelectedCountryCode('IN');
          setErrors({}); // Clear all errors on successful submission
          setShowThankYou(true);
          setSuccessAlert(true);
        })
        .catch((error) => {
          console.error("Error submitting data:", error);
          
          // Handle validation errors from server
          if (error.response && error.response.status === 400 && error.response.data) {
            const serverErrors = {};
            const errorData = error.response.data;
            
            // Convert server errors to format expected by the form
            Object.keys(errorData).forEach(field => {
              if (Array.isArray(errorData[field])) {
                serverErrors[field] = errorData[field].join(', ');
              } else {
                serverErrors[field] = errorData[field];
              }
            });
            
            console.log('Server validation errors:', serverErrors);
            setErrors(serverErrors);
          } else {
            // For other types of errors, show general error alert
            setErrorAlert(true);
          }
        });
    } else {
      setErrors(formErrors);
    }
  };
  const [showThankYou, setShowThankYou] = useState(false);

  return (
    <div>
      <Hero anim={anim} />

      <div className="container-width">
        {/* About us section */}
        <section className="aboutus-section" id="aboutus">
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 about-us-img-main-container">
            <img {...getAosData("fade-right", 0)} src={Aboutusimg} alt="About Mariners Mentor" />
          </div>
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="aboutus-section-info">
              <h4 {...getAosData("fade-up", 0)} className="">
                About us
              </h4>
              <h2
                {...getAosData("fade-up", 100)}
                className="pt-3 pb-3 section-title"
              >
                Providing accessible, high-quality Services and Career Guidance
                to seafarers globally
              </h2>
              <p
                {...getAosData("fade-up", 200)}
                className="about-us-txt lh-sm-0.8 lh-lg-1.5 lh-xl-2"
              >
                Our mission is to empower the next generation of mariners with
                cutting-edge knowledge, practical skills, and industry insights.
                With years of experience in the maritime sector, we've
                established ourselves as trusted partners for seafarer training
                and professional development.
              </p>
            </div>
          </div>
        </section>
        {/* Services section */}
        <Affairs anim={anim} />

        <Services anim={anim} />

        {/* Testimonial section */}
        <section
          className="testimonial-section pt-5 mb-5 container-width"
          id="testimonial"
        >
          <Reviews anim={anim} />
        </section>

        <section
          id="faq-section"
          className="faq-section container-width pt-5 mb-5"
        >
          <div className="row row-cols-1 row-cols-md-2 ">
            <div className="col faq-txt-section">
              <h4 {...getAosData("fade-left", 100)} className="fs-2">
                FAQs
              </h4>
              <h2
                {...getAosData("fade-up", 300)}
                className="section-title pt-2 mb-3 fs-5"
              >
                Want to know more?
              </h2>
              <p {...getAosData("fade-up", 400)} className="text-start mb-4">
                These are some of the most asked queries, look out for general
                help. Duis scelerisque at lectus nec egestas. Maecenas quis
                placerat dolor, vitae consequat mi. Etiam eleifend velit ut
                cursus porta. Maecenas ut ipsum varius, placerat ex eget,
                vehicula quam. Nam mollis molestie blandit. Donec odio eros,
                accumsan sed rhoncus porttitor,
              </p>
            </div>
            <div {...getAosData("fade-right", 500)} className="col">
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    {" "}
                    What kind of coaching is available to help advance my
                    career?
                  </Accordion.Header>
                  <Accordion.Body>
                    Career transition coaching supports individuals who are
                    looking to change careers or industries. Coaches assist with
                    resume building, interview preparation, and job search
                    strategies, ensuring a smooth and successful transition."
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    {" "}
                    What is the typical career path for someone starting as a
                    seafarer?
                  </Accordion.Header>
                  <Accordion.Body>
                    "The typical career path for a seafarer starting as a deck
                    cadet includes several stages. After gaining experience and
                    completing necessary certifications, a deck cadet can be
                    promoted to Third Officer, then Second Officer, First
                    Officer, and ultimately Captain. Each step involves
                    increased responsibilities, including navigation, cargo
                    handling, and crew management."
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    {" "}
                    What training courses does the company offer for career
                    development?
                  </Accordion.Header>
                  <Accordion.Body>
                    Our Seafeares Essentials course is designed to develop your
                    leadership skills, focusing on areas such as effective
                    communication, decision-making, and team management. This
                    course prepares you for higher-level roles within the
                    company."
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    {" "}
                    How can I keep updated about my Coursers Expiration?
                  </Accordion.Header>
                  <Accordion.Body>
                    "Our system sends automated email alerts to notify you when
                    your courses are nearing their expiration date. You'll
                    receive reminders well in advance, ensuring you have ample
                    time to complete any necessary renewals or updates."
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    {" "}
                    Can You Provide Remote Support for Consulation ?
                  </Accordion.Header>
                  <Accordion.Body>
                    "Yes, we offer virtual consultation services to provide you
                    with the support you need, no matter where you are located.
                    Our experts are available for video calls, phone
                    consultations, and online chats to address your questions
                    and concerns."
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </section>

        <Explorevideos anim={anim} />

        <section
          className="getintouch-section container-width pb-5 mt-3 pt-5"
          id="getintouchform"
          {...getAosData("fade-up", 100)}
        >
          {errorAlert && (
            <Alert variant="danger">
              Error in Submitting form , Please try again
            </Alert>
          )}
          <div className="row row-cols-xxl-2 row-cols-xl-2 row-cols-lg-2 row-cols-md-1  row-cols-sm-1">
            <div className="getintouch-img-main-container">
              <div className="getintouch-img">
                <img src={Getintouchimg} alt="Get in touch with Mariners Mentor" />
              </div>
            </div>
            <div className="col">
              <div className="form-content">
                <h4 className="form-content-head mb-4">Inquiry</h4>
                <h1 className="section-title mb-4">Let's Get in Touch</h1>
                <p>
                  We are glad to stay connected with you so that you would
                  receive Frequent updates about us and our services
                </p>
              </div>

              <form className="mt-4" onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-12 col-md-6 col-sm-6">
                    <label className="form-label">INDOS Number</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter INDOS Number"
                      id="customField"
                      name="indos_no"
                      value={formData.indos_no}
                      onChange={handleChange}
                      maxLength={8}
                    />
                    {errors.indos_no && (
                      <p className="error">{errors.indos_no}</p>
                    )}
                  </div>

                  <div className="col-12 col-md-6 col-sm-6">
                    <label className="form-label">
                      First Name<span className="error ms-1">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleChange}
                      placeholder="Enter First Name"
                    />
                    {errors.first_name && (
                      <p className="error">{errors.first_name}</p>
                    )}
                  </div>

                  <div className="col-12 col-md-6 col-sm-6">
                    <label className="form-label">Last Name</label>
                    <input
                      className="form-control"
                      type="text"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleChange}
                      placeholder="Enter Last Name"
                    />
                    {errors.last_name && <p className="error">{errors.last_name}</p>}
                  </div>

                  <div className="col-12 col-md-6 col-sm-6">
                    <label className="form-label">
                      E-mail Address<span className="error ms-1">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="email"
                      name="email"
                      placeholder="Enter E-mail Address"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && <p className="error">{errors.email}</p>}
                  </div>

                  <div className="col-12 col-md-6 col-sm-6">
                    <label className="form-label">Date of Birth</label>
                    <input
                      className="form-control"
                      type="date"
                      name="date_of_birth"
                      onChange={handleChange}
                      value={formData.date_of_birth}
                      placeholder="Choose Date of Birth"
                      max={new Date().toISOString().split("T")[0]}
                    />
                    {errors.date_of_birth && (
                      <p className="error">{errors.date_of_birth}</p>
                    )}
                  </div>

                  <div className="col-12 col-md-6 col-sm-6">
                    <label className="form-label">Phone Number</label>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      {/* Country Code Selector */}
                      <select
                        className="form-control"
                        style={{ flex: '0 0 110px', fontSize: '14px' }}
                        value={selectedCountryCode}
                        onChange={(e) => {
                          setSelectedCountryCode(e.target.value);
                          setFormData(prev => ({ ...prev, country_code: e.target.value }));
                          // Clear phone-related errors when country changes
                          setErrors(prevErrors => {
                            const newErrors = { ...prevErrors };
                            delete newErrors.phone;
                            delete newErrors.country_code;
                            return newErrors;
                          });
                        }}
                      >
                        {loadingCountries ? (
                          <option disabled>Loading...</option>
                        ) : (
                          countries.map((country) => (
                            <option key={country.code} value={country.code}>
                              {country.phone} ({country.name})
                            </option>
                          ))
                        )}
                      </select>
                      
                      {/* Phone Number Input */}
                      <input
                        className="form-control"
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="Enter local number"
                        style={{ flex: '1' }}
                      />
                    </div>
                    {errors.phone && <p className="error">{errors.phone}</p>}
                  </div>

                  <div className="col-12 col-md-6 col-sm-6">
                    <label className="form-label">Current Designation</label>
                    <input
                      className="form-control"
                      type="text"
                      name="designation"
                      value={formData.designation}
                      onChange={handleChange}
                      placeholder="Enter Current Designation"
                    />
                    {errors.designation && <p className="error">{errors.designation}</p>}
                  </div>

                  <div className="col-12 col-md-6 col-sm-6">
                    <label className="form-label">
                      Location (City, Country)
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter Location"
                      name="location"
                      value={formData.location}
                      onChange={handleChange}
                    />
                    {errors.location && <p className="error">{errors.location}</p>}
                  </div>

                  <div className="col-12">
                    <label className="form-label">
                      Message<span className="error ms-1">*</span>
                    </label>
                    <textarea
                      className="form-control"
                      placeholder="Write a message"
                      rows="4"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                    />
                    {errors.message && (
                      <p className="error">{errors.message}</p>
                    )}
                  </div>

                  <div className="col-12 ">
                    <button
                      className="btn btn-primary primary-btn mt-4"
                      type="submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <ThankYouAnimation
              isVisible={showThankYou}
              onClose={() => setShowThankYou(false)}
            />
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}
export default Home;
